import { Container, SxProps, Theme, useTheme } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import Footer from "./Footer";
import Header from "./Header";
import SkipToContent from "./SkipToContent";

interface LayoutProps {
  sx?: SxProps<Theme>;
  children?: React.ReactNode;
  fixedFooterPages: Array<string>;
}
export function Layout({ sx, children, fixedFooterPages }: LayoutProps) {
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        height: "100vh",
        bgcolor: theme.palette.background.default,
      }}
    >
      <SkipToContent />
      <Header />
      <Container
        id="main_content"
        component="main"
        tabIndex={-1}
        sx={{
          ...sx,
          p: { xs: 0 },
          pl: { xs: 2, sm: 6, md: 0 },
          pr: { xs: 2, sm: 6, md: 0 },
          flexGrow: 1,
        }}
        maxWidth={"sm"}
      >
        {children}
      </Container>
      <Footer fixedPages={fixedFooterPages} />
    </Box>
  );
}
